<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">فرم ثبت اطلاعات مهارت</h5>
    <form [formGroup]="AddNewSkill" (submit)="SubmitAddNewSkill()">

      <input type="hidden" formControlName="id" />

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">عنوان</label>
          <input formControlName="Title" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_Title().valid && get_Form_Title().touched"
            class="form-text text-muted MyErrorRedColor">عنوان را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">امتیاز</label>
          <input formControlName="Rate" type="number" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_Rate().valid && get_Form_Rate().touched"
            class="form-text text-muted MyErrorRedColor">امتیاز را وارد نمائید.</small>
        </div>
      </div>
      <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
      <button *ngIf="!InProccessing" type="submit" [disabled]="!AddNewSkill.valid" class="btn btn-success"
        style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
      <button *ngIf="!InProccessing" type="reset" class="btn btn-danger" style="margin-left: 5px;"><i
          class="fa fa-times-rectangle"></i> لغو </button>
      <button routerLink="/Skill" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i
          class="fa fa-mail-reply"></i> بازگشت </button>
    </form>
  </div>
</div>